// extracted by mini-css-extract-plugin
export default {"formField":"ira-z","error":"jra-z","disabled":"kra-z","fieldError":"lra-z","errorText":"mra-z","button":"nra-z","acknowledgment":"ora-z"};